var Component = require("!../../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./NovaJustificativa.vue"),
  /* template */
  require("!!../../../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-47581214\",\"hasScoped\":false}!../../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./NovaJustificativa.vue"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/app/policia-civil/diarias/justificativa/components/NovaJustificativa.vue
// module id = 1340
// module chunks = 18